package one.healthium.uscreen.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UScreenGroup(
    @SerialName("label") val label: String,
    @SerialName("color") val color: String,
    @SerialName("screens") val screens: List<UScreen>,
) {
    companion object {
        val preview = UScreenGroup(
            label = "Goals",
            color = "#C9A84C",
            screens = listOf(
                UScreen(
                    id = "goal",
                    blocks = listOf(
                        LabelBlock.preview,
                        SpacerBlock(height = 16),
                        ChoiceListBlock.preview,
                    ),
                    cta = UScreenCta.preview,
                ),
                UScreen(
                    id = "motivation",
                    blocks = listOf(
                        ImageBlock.preview,
                        SpacerBlock(flex = 1f),
                        LabelBlock.preview,
                    ),
                    cta = UScreenCta.preview,
                ),
            ),
        )
    }
}
